<wiz-vgroup width="100%" height="100%" horizontalAlign="center" gap="2" class="insert clickable-widget">
  <wiz-hgroup
    width="100%"
    height="20px"
    verticalAlign="center"
    (dblclick)="selectMe($event)"
    padding="3px"
    gap="2"
    style="cursor: pointer"
    class="insert-header"
  >
    <wiz-label
      #lbTitle
      width="100%"
      [wizLabel]="data.fullCode"
      [wizTextBehavior]="'truncate'"
      class="insert-title-10"
    ></wiz-label>
  </wiz-hgroup>
  <wiz-group
    width="100%"
    height="100%"
    style="cursor: pointer; font-size: 9px"
    verticalAlign="center"
    horizontalAlign="center"
  >
    <wiz-icon *ngIf="showPen" style="font-size: 18px">edit</wiz-icon>
    <wiz-icon *ngIf="showWeight" style="font-size: 18px">weight-grid</wiz-icon>
    <wiz-icon *ngIf="showConstant" style="font-size: 18px">constant</wiz-icon>
    <wiz-label
      #lbContent
      [wizLabel]="currentFormula"
      width="100%"
      padding="3px"
      [wizNbLine]="3"
      [wizTextBehavior]="'wordWrap'"
      *ngIf="!showPen"
    ></wiz-label>
  </wiz-group>
</wiz-vgroup>
